<template>
  <div class="new-journal">
    <div class="wrapper-header">
      <HeaderNewCopy :hasHeaderLine="hasHeaderLine" :mobHasMenu="false" />
    </div>
    <Currencies />

    <!-- Desktop -->
    <div class="investments-page">
      <template v-for="n in currentPage">
        <template v-if="onePagePosts">
          <InvestPostList :key="'posts_list_' + n" :posts="onePagePosts[n - 1]" />
        </template>
      </template>

      <div v-observe-visibility="handleScrolledToBottom"></div>
      <div class="loader-wrapper" v-if="showLoader">
        <img src="@/assets/img/circle-loader.svg" class="circle-loader">
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import HeaderNewCopy from '@/components/newRedesign/HeaderNewCopy.vue';
import Footer from '@/components/newRedesign/FooterNewCopy.vue';
import Currencies from '@/components/redesign/Currencies.vue';
import request from '@/api/axios';
import InvestPostList from '@/components/newRedesign/InvestPostList.vue';

export default {
  name: 'Investments',
  data: () => {
    return {
      posts: [],
      showLoader: true,
      lastPage: 1,
      currentPage: 1,
      postsOnPage: 5,
      onePagePosts: [],
      hasHeaderLine: true
    }
  },
  components: {
    HeaderNewCopy,
    Footer,
    Currencies,
    InvestPostList
  },
  computed: {
  },
  async created() {
    this.data = (await this.getPosts()).data;
    const posts = this.data.posts
    this.lastPage = Math.ceil(posts.length / this.postsOnPage)
    this.onePagePosts = this.getPostsPages(posts)
  },
  methods: {
    async getPosts() {
      return (await request({ action: 'get_posts' }));
    },
    handleScrolledToBottom(isVisible) {
      if (!isVisible) { return }
      if (this.currentPage >= this.lastPage) { return }
      this.showLoader = true
      this.currentPage++
      this.showLoader = false
    },
    getPostsPages(posts) {
      if (!posts) return [];
      let weight = 0;
      let curIndex = 0;
      return posts.reduce((acc, item) => {
        weight++
        if (weight > this.postsOnPage) {
          weight = 1
          curIndex++
        }
        if (!acc[curIndex]) acc[curIndex] = [];
        acc[curIndex].push(item);
        return acc;
      }, []);
    },
  }
}
</script>

<style scoped lang="scss">

.new-journal {
  padding-top: 120px;

  .investments-page {
    width: 1024px;
    margin-right: auto;
    margin-left: auto;
    background-color: #fff;
  }

  .circle-loader {
    animation: animate 1.5s infinite linear;
  }

  @keyframes animate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .loader-wrapper {
    width: 32px;
    height: 31px;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 40px;
  }


  @media screen and (max-width: 650px) {
    .investments-page {
      width: 289px;
    }

    .loader-wrapper {
      margin-top: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
